// extracted by mini-css-extract-plugin
export default {"teamRow":"featureStyles_teamRow__3EXh1"};